import { createContext } from 'react';
import { DialogProps } from '@material-ui/core';

type DialogContextType = Pick<DialogProps, 'onClose'>;

export const DialogContext = createContext({} as DialogContextType);
